import React from 'react'
import ReactDOM from 'react-dom'
import Root from './Root'
import { unregister } from './registerServiceWorker'
import * as Sentry from '@sentry/react'
import './interceptors'
import { getAmbiente, isAmbienteProd } from './util/applicationContext'
import { getAuthentication } from './security/securityContext'

if (isAmbienteProd()) {
  Sentry.init({
    dsn: 'https://cc1657267cfd34ff32ab6b12b2fcd864@o4508762339344384.ingest.us.sentry.io/4509016388206592',
    environment: getAmbiente(),
    release: process.env.REACT_APP_VERSION,
    beforeSend(event) {
      event.extra = { usuario: getAuthentication()?.username }
      if (event.exception && event.exception.values && event.exception.values.length > 0) {
        if (
          event.exception.values.some(
            (ex) =>
              ex.value.includes('Request failed with status code 412') ||
              ex.value.includes('Request failed with status code 401') ||
              ex.value.includes('Request failed with status code 403') ||
              ex.value.includes('Network Error') ||
              ex.value.includes('Request aborted') ||
              ex.value.includes('Unexpected token .') || // erro do newrelic
              ex.value.includes('The operation is insecure')
          )
        ) {
          return null
        }
      }
      return event
    }
  })
}

ReactDOM.render(<Root />, document.getElementById('root'))
unregister()
